import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Show = createSvgIcon(
  <path d="M23.64 11.85c-.157-.3-3.968-7.35-11.685-7.35C4.237 4.5.435 11.55.277 11.85L0 12.375l.278.525c.157.3 3.967 7.35 11.684 7.35 7.718 0 11.528-7.05 11.686-7.35l.277-.525-.277-.525h-.008ZM11.962 18c-5.227 0-8.4-4.14-9.374-5.625.974-1.492 4.147-5.625 9.375-5.625 5.227 0 8.4 4.14 9.374 5.625C20.363 13.867 17.19 18 11.963 18Z M11.963 15.375a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />,
  'Show'
);

export { Show };
